import staticAssetsPath from './static-assets-path';

const genders = {
    M: 'men',
    F: 'women',
};

const fallbackImages = {
    men: staticAssetsPath('img/pickers/men.svg'),
    women: staticAssetsPath('img/pickers/women.svg'),
};

/**
 * Get a piker image or fallback to one gender specific
 * @param {object} picker - picker model
 * @returns {string} the path to the image
 */
export default function getPickerImage(picker) {
    const gender = genders[picker.gender];
    const pic = picker.profile_picture;
    return pic || fallbackImages[gender];
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/get-picker-image.js